<template>
  <div id="entire_app__profile">
    <Toast />
    <div v-if="$store.state.SidebarToggle.loadingPageData" :class="{'--booking_in_progress': $store.state.SidebarToggle.loadingPageData}" class="ticket_booking_order">
      <div class="ticking_procedure_background loading_data_background"></div>
      <div class="error_occurred_container">
        <div class="alert_container loading_container col-mob-11">
          <img class="logo col-mob-5" src="../../assets/logo.png" alt="">
          <img class="loader" src="../../assets/loading.gif" alt="">
        </div>
      </div>
    </div> 
    <div
      class="entire_app__sidebar_container"
      :class="{
        '--sidebar_toggled': $store.state.SidebarToggle.sidebar_toggled,
      }"
    >
      <ShaloiSidebar />
    </div>
      <div class="entire_app_mobile_sidebar_container" v-if="$store.state.Customizations.mobile_siderbar_toggled">
        <shaloi-mobile-sidebar/>
      </div>

      <div class="__mobile_navigation">
        <div class="logo_container">
          <div class="menu_toggle">
            <svg id="menu" @click="$store.commit('Customizations/togglemobilesidebar')" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 28 28">
              <path id="Path_1" data-name="Path 1" d="M0,0H28V28H0Z" fill="none"/>
              <path id="Path_2" data-name="Path 2" d="M18.889,21.5V24H5.444V21.5ZM25,12.75v2.5H3v-2.5ZM22.556,4V6.5H9.111V4Z" transform="translate(0)" fill="#1d2329"/>
            </svg>
          </div>
          <div class="logo">
            <img src="../../assets/logo.png" alt="logo">
          </div>
          <div class="settings">
            <router-link to="/shaloi/profile"><svg @click="$store.commit('Customizations/togglemobilesidebartofalse')" id="settings" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 28 28">
              <path id="Path_3" data-name="Path 3" d="M0,0H28V28H0Z" fill="none"/>
              <path id="Path_4" data-name="Path 4" d="M2,14a12.19,12.19,0,0,1,.379-3.024A3.6,3.6,0,0,0,5.685,9.171a3.642,3.642,0,0,0-.1-3.784,11.971,11.971,0,0,1,5.2-3.025,3.59,3.59,0,0,0,6.418,0,11.971,11.971,0,0,1,5.2,3.025,3.642,3.642,0,0,0-.1,3.786,3.6,3.6,0,0,0,3.308,1.805,12.239,12.239,0,0,1,0,6.046,3.6,3.6,0,0,0-3.307,1.8,3.642,3.642,0,0,0,.1,3.785,11.971,11.971,0,0,1-5.2,3.025,3.59,3.59,0,0,0-6.418,0,11.971,11.971,0,0,1-5.2-3.025,3.642,3.642,0,0,0,.1-3.786,3.6,3.6,0,0,0-3.308-1.805A12.215,12.215,0,0,1,2,14Zm5.765,3.623a6.065,6.065,0,0,1,.677,4.255A9.594,9.594,0,0,0,10,22.783a5.975,5.975,0,0,1,8,0,9.594,9.594,0,0,0,1.556-.906,6.062,6.062,0,0,1,.677-4.255,6,6,0,0,1,3.324-2.717,9.873,9.873,0,0,0,0-1.811,6,6,0,0,1-3.325-2.717,6.062,6.062,0,0,1-.677-4.255A9.572,9.572,0,0,0,18,5.217a5.973,5.973,0,0,1-8,0,9.573,9.573,0,0,0-1.556.906,6.062,6.062,0,0,1-.677,4.255,6,6,0,0,1-3.324,2.717,9.873,9.873,0,0,0,0,1.811,6,6,0,0,1,3.325,2.717Zm6.235,0A3.623,3.623,0,1,1,17.6,14,3.611,3.611,0,0,1,14,17.623Zm0-2.415A1.208,1.208,0,1,0,12.8,14,1.2,1.2,0,0,0,14,15.208Z" transform="translate(0 0)" fill="#1d2329"/>
            </svg></router-link>
          </div>
        </div>
  </div>
    <div
      class="entire_app__page_content"
      :class="{
        '--sidebar_toggled_expd_body':
          $store.state.SidebarToggle.sidebar_toggled,
      }"
    >
      <h5>
        <svg
          id="pulse-fill"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        >
          <path
            id="Path_31"
            data-name="Path 31"
            d="M0,0H24V24H0Z"
            fill="none"
          />
          <path
            id="Path_32"
            data-name="Path 32"
            d="M9,7.539l6,14L18.659,13H23V11H17.341L15,16.461l-6-14L5.341,11H1v2H6.659Z"
            fill="#1d2329"
          />
        </svg>
        Account settings
      </h5>
      <div class="form">
        <form>
          <div class="pair">
            <div class="input-item">
              <label for="fname">Firstname</label>
              <input
                type="text"
                name="fname"
                v-model="fname"
                placeholder="Firstname"
                id="fname"
                required
              />
            </div>
            <div class="input-item">
              <label for="lname">Lastname</label>
              <input
                type="text"
                name="lname"
                v-model="lname"
                placeholder="Lastname"
                id="lname"
                required
              />
            </div>
          </div>
          <div class="pair">
            <div class="input-item">
              <label for="gender">Gender</label>
              <select
                v-if="$store.state.UserDetails.user.gender === 'M'"
                name="gender"
                v-model="gender"
                required
              >
                <option value="M">Male</option>
                <option value="F">Female</option>
              </select>
              <select v-else name="gender" v-model="gender" required>
                <option value="F">Female</option>
                <option value="M">Male</option>
              </select>
            </div>
          </div>
          <div class="imgpair">
            <div class="input-pair">
              <div class="input-item location">
                <label for="location">Location</label>
                <input
                  type="text"
                  name="location"
                  id="location"
                  placeholder="Location"
                  v-model="location"
                />
              </div>
              <div class="input-item">
                <label for="age">Age</label>
                <input
                  type="number"
                  name="age"
                  v-model="age"
                  placeholder="Age"
                  id="age"
                />
              </div>
            </div>
            <div class="input-img">
              <label>Profile picture</label>
              <input
                type="file"
                name="newlyuploaded"
                @change="handleChange"
                id="profilepic"
                accept="image/x-png,image/jpeg,image/jpg"
                class="profilepic"
              />
              <div class="output">
                <label class="pencil" for="profilepic">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="30"
                    height="30"
                    viewBox="0 0 36 36"
                  >
                    <g
                      id="Ellipse_21"
                      data-name="Ellipse 21"
                      fill="#fff"
                      stroke="none"
                      stroke-width="3"
                    >
                      <circle cx="18" cy="18" r="18" stroke="none" />
                      <circle
                        cx="18"
                        cy="18"
                        r="16.5"
                        fill="rgba(0, 0, 0, 0.7)"
                      />
                    </g>
                    <path
                      id="Icon_material-edit"
                      data-name="Icon material-edit"
                      d="M4.5,14.98v2.758H7.718L17.209,9.6,13.991,6.845ZM19.7,7.47a.661.661,0,0,0,0-1.037L17.689,4.711a.958.958,0,0,0-1.21,0l-1.57,1.346,3.218,2.758Z"
                      transform="translate(5.776 6.882)"
                      fill="#fff"
                    />
                  </svg>
                </label>
                <img v-if="newlyuploaded" :src="newlyuploaded" />
                <img
                  v-else-if="$store.state.UserDetails.user.photo == ''"
                  src="@/assets/default.png"
                  alt="avatar"
                />
                <img
                  v-else
                  draggable="false"
                  :src="
                      $store.state.UserDetails.user.photo
                  "
                  alt="avatar"
                />
              </div>
            </div>
          </div>
          <div class="buttons">
            <button
              type="button"
              class="show-modal bad"
              data-toggle="modal"
              :data-target="myModal"
            >
              change password
            </button>
            <button type="submit" class="good" @click.prevent="saveProfile()">
              save changes
              <span
                v-if="hasSubmitted"
                class="spinner-border spinner-border-sm ml-2 my-auto"
              ></span>
            </button>
          </div>
        </form>
      </div>

      <div class="modal fade" id="myModal">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-body">
              <h5 class="text-primary myModal-heading mb-4">Change password</h5>
              <form class="modalform">
                <div class="mx-auto">
                  <div class="form-group">
                    <input
                      type="password"
                      class="form-control"
                      name="cpwd"
                      v-model="cpwd"
                      placeholder="Current password"
                      required
                    />
                  </div>
                  <div class="form-group">
                    <input
                      type="password"
                      class="form-control"
                      name="npwd"
                      v-model="npwd"
                      placeholder="New password"
                      required
                    />
                  </div>
                  <div class="form-group">
                    <input
                      type="password"
                      class="form-control"
                      name="cnpwd"
                      v-model="cnpwd"
                      placeholder="Confirm password"
                      required
                    />
                  </div>
                </div>
                <div class="text-center regbp">
                  <button
                    type="button"
                    class="btn btn-secondary"
                    :data-dismiss="modalClose"
                    @click="register"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    name="changepw"
                    @click.prevent="changepw()"
                    class="btn btn-primary"
                  >
                    Change password
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div class="phone_number_update">
        <label for="tel">Update phone number(new number should contain country code)</label>
        <form>
          <div class="input-item">
            <input
              type="number"
              name="tel"
              id="tel"
              minlength="8"
              maxlength="20"
              v-model="telephone"
              placeholder="Phonenumber"
              :readonly="MakeReadonly"
              pattern="^[+][(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$"
              required
            />
          </div>
          <button
            type="button"
            :disabled="isDisabled"
            class="btn"
            @click="updatePhone"
          >
            Send verification code
            <span
              v-if="initialSubmit"
              class="spinner-border spinner-border-sm ml-2 my-auto"
            ></span>
          </button>
        </form>
        <div class="loading" v-if="initialSubmit">
          <span
            v-if="initialSubmit"
            class="spinner-border spinner-border-sm ml-2 my-auto"
          ></span>
          <p>Loading....</p>
        </div>
        <form class="mt-3" v-if="showCodeInput">
          <div class="input-item">
            <input
              type="number"
              name="tel"
              id="tel"
              minlength="8"
              maxlength="20"
              v-model="codeSent"
              placeholder="Enter verification code"
              required
            />
          </div>
          <div class="d-flex updatePhoneButtons">
            <button type="button" class="btn" @click="VerifyCode">
              Update phone
              <span
                v-if="finalsubmit"
                class="spinner-border spinner-border-sm ml-2 my-auto"
              ></span>
            </button>
            <button class="btn edit" title="Edit phone" @click="EditPhone">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="24"
                height="24"
              >
                <path fill="none" d="M0 0h24v24H0z" />
                <path
                  d="M9.243 19H21v2H3v-4.243l9.9-9.9 4.242 4.244L9.242 19zm5.07-13.556l2.122-2.122a1 1 0 0 1 1.414 0l2.829 2.829a1 1 0 0 1 0 1.414l-2.122 2.121-4.242-4.242z"
                  fill="rgba(255,255,255,1)"
                />
              </svg>
            </button>
          </div>
        </form>
      </div>

      <!-- </div> -->
    </div>
  </div>
</template>

<script>
import ShaloiSidebar from "@/components/ShaloiSidebar.vue"; // @ is an alias to /src
import Axios from "axios";
import $ from "jquery";

import router from "../../router/index";
import ShaloiMobileSidebar from "@/components/ShaloiMobileSidebar.vue";
import jwt_decode from "jwt-decode";
import axios from "axios";
const sendCodeUrl = "https://bookinga.herokuapp.com/api/v1/client/resendCode";
const codeUrl =
  "https://bookinga.herokuapp.com/api/v1/client/verifyResetPassCode";
let config = {
  headers: {
    Authorization: "Bearer " + localStorage.getItem("jwt"),
  },
};
export default {
  components: {
    ShaloiSidebar,
    ShaloiMobileSidebar
  },
  data() {
    return {
      newlyuploaded: "",
      file: "",
      modalClose: "",
      myModal: "",
      cpwd: "",
      npwd: "",
      cnpwd: "",
      fname: "",
      lname: "",
      telephone: "",
      gender: "",
      finalsubmit: false,
      initialSubmit: false,
      codesent: "",
      MakeReadonly: false,
      showCodeInput: false,
      isDisabled: false,
      location: "",
      age: "",
      hasSubmitted: false,
    };
  },
  methods: {
    getShaloiStatus() {
      axios
        .get(
          "https://bookinga.herokuapp.com/api/v1/company/shaloi/hasbranch",
          config
        )
        .then((result) => {
          if (result.data.data[0].hasbranch == false) {
            return router.push("/shaloi/NoBranch");
          }
        })
        .catch((err) => {});
    },
    handleChange(e) {
      this.file = e.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(e.target.files[0]);
      reader.onload = (event) => {
        this.newlyuploaded = event.target.result;
      };
    },
    updatePhone() {
      let newPhone = this.$store.state.UserDetails.user.telephone;
      if (this.telephone == newPhone) {
        return this.$toast.add({
          severity: "error",
          summary: "An error occured",
          detail: "You're trying to submit the same number",
          life: 5000,
        });
      } else if (this.telephone.length < 8 || this.telephone.length > 14) {
        return this.$toast.add({
          severity: "warn",
          summary: "Warning",
          detail: "The new phone number should be valid",
          life: 5000,
        });
      } else if (this.telephone == "") {
        return this.$toast.add({
          severity: "warn",
          summary: "Phone is required",
          detail: "The phone number field should not be empty",
          life: 5000,
        });
      } else {
        this.initialSubmit = true;
        axios
          .post(sendCodeUrl, {
            Telephone: `+${this.telephone}`,
          })
          .then((res) => {
            if (res.data.success == true) {
              this.initialSubmit = false;
              this.showCodeInput = true;
              this.isDisabled = true;
              this.MakeReadonly = true;
              return this.$toast.add({
                severity: "success",
                summary: "Verification code sent",
                detail:
                  "Enter the verification code sent to the provided number in the input box provided",
                life: 5000,
              });
            } else {
              this.initialSubmit = false;
              return this.$toast.add({
                severity: "error",
                summary: "An error occured",
                detail: res.data.message,
                life: 5000,
              });
            }
          });
      }
    },

    VerifyCode() {
      if (this.codeSent == undefined) {
        return this.$toast.add({
          severity: "warn",
          summary: "Code sent is required",
          detail: "The sent code field should not be empty",
          life: 5000,
        });
      } else if (this.codeSent.length != 6) {
        return this.$toast.add({
          severity: "warn",
          summary: "Code entered is invalid",
          detail: "The code entered is invalid",
          life: 5000,
        });
      } else {
        this.finalsubmit = true;
        axios
          .post(codeUrl, {
            Telephone: `+${this.telephone}`,
            code: this.codeSent,
          })
          .then((res) => {
            if (res.data.success == true) {
              this.finalsubmit = false;
              this.showCodeInput = false;
              this.MakeReadonly = false;
              this.isDisabled = true;
              return this.$toast.add({
                severity: "success",
                summary: "Phone number Updated",
                detail: "Your phone number has been updated successfully",
                life: 5000,
              });
            }
          })
          .catch((err) => {
            this.finalsubmit = false;
            return this.$toast.add({
              severity: "error",
              summary: "An error occured",
              detail: err.response.data.message,
              life: 5000,
            });
          });
      }
    },
EditPhone(){
  this.MakeReadonly = false;
  this.isDisabled = false;
  this.showCodeInput=false
},
    saveProfile() {
      if (this.fname != "" && this.lname != "" && this.age != "") {
        this.hasSubmitted = !this.hasSubmitted;

        //userinfo
        Axios.put(
          "https://bookinga.herokuapp.com/api/v1/client/updateClient",
          {
            Firstname: this.fname,
            Lastname: this.lname,
            gender: this.gender,
            age: this.age,
            location: this.location,
          },
          config
        )
          .then((response) => {
            if (response.data.success == true) {
              this.$toast.add({
                severity: "success",
                summary: "Done!",
                detail: "Your credentials changed successful!",
                life: 5000,
              });

              if (!this.file) {
                this.hasSubmitted = false;
                let count = 0;
                let timing = setInterval(() => {
                  if (count > 0) {
                    let updatedData = {
                      "Firstname": this.fname,
                      "Lastname": this.lname,
                      "gender": this.gender,
                      "age": this.age,
                      "location": this.location,
                    }
                    this.$store.commit("UserDetails/updateUserData", updatedData);
                    clearInterval(timing);
                  }
                  count++;
                }, 500);
              } 
            } else {
              this.hasSubmitted = false;
              return this.$toast.add({
                severity: "error",
                summary: "An error occured",
                detail: response.data.message,
                life: 5000,
              });
            }
          })
          .catch((error) => {
            this.hasSubmitted = false;
            return this.$toast.add({
              severity: "error",
              summary: "An error occured",
              // detail: error,
              detail: "an error occured, try again later",
              life: 5000,
            });
          });

        //profile picture
        if(this.file){  
        const fd = new FormData();
        fd.append("photo", this.file);
        Axios.put(
          "https://bookinga.herokuapp.com/api/v1/client/photo",
          fd,
          config
        )
          .then((response) => {
            if (response.data.success == true) {
              // console.log(response);
              this.hasSubmitted = false;
              this.$toast.add({
                severity: "success",
                summary: "Done!",
                detail: "Your profile picture saved successful!",
                life: 5000,
              });

                let url = this.newlyuploaded;
                this.$store.commit('UserDetails/updateProfilePicture', url);

              let count = 0;
                let timing = setInterval(() => {
                  if (count > 0) {
                    let updatedData = {
                      "Firstname": this.fname,
                      "Lastname": this.lname,
                      "gender": this.gender,
                      "age": this.age,
                      "location": this.location,
                    }
                    this.$store.commit("UserDetails/updateUserData", updatedData);
                    clearInterval(timing);
                  }
                  count++;
                }, 500);
            } else {
              this.hasSubmitted = false;
              return this.$toast.add({
                severity: "error",
                summary: "An error occured",
                detail: response.data.message,
                life: 5000,
              });
            }
          })
          .catch((error) => {
            this.hasSubmitted = false;
            return this.$toast.add({
              severity: "error",
              summary: "An error occured",
              detail: error.response.data.message,
              life: 5000,
            });
          });
      }
      } else {
        return this.$toast.add({
          severity: "error",
          summary: "An error occured",
          detail: "Firstname, lastname and gender are required",
          life: 5000,
        });
      }
    },
    changepw() {
      if (this.cpwd != "" && this.npwd != "" && this.cnpwd != "") {
        if (this.npwd == this.cnpwd) {
          Axios.put(
            "https://bookinga.herokuapp.com/api/v1/client/updatePassword",
            {
              currentPassword: this.cpwd,
              newPassword: this.npwd,
              confirmPassword: this.cnpwd,
            },
            config
          )
            .then((response) => {
              if (response.data.success == true) {
                this.cpwd = "";
                this.npwd = "";
                this.cnpwd = "";
                // this.modalClose = "modal";
                return this.$toast.add({
                  severity: "success",
                  summary: "Done!",
                  detail: "password changed successful!",
                  life: 5000,
                });
              } else {
                return this.$toast.add({
                  severity: "error",
                  summary: "An error occured",
                  detail: response.data.message,
                  life: 5000,
                });
              }
            })
            .catch((error) => {
              return this.$toast.add({
                severity: "error",
                summary: "An error occured",
                // detail: error,
                detail: "an error occured, try again later",
                life: 5000,
              });
            });
        } else {
          return this.$toast.add({
            severity: "error",
            summary: "An error occured",
            detail: "New password must be similar to confirm new password",
            life: 5000,
          });
        }
      } else {
        return this.$toast.add({
          severity: "error",
          summary: "An error occured",
          detail: "All the 3 fields required to change password",
          life: 5000,
        });
      }
    },
    register() {
      this.modalClose = "modal";
    },
  },
  watch: {
    user() {
      this.fname = this.$store.state.UserDetails.user.firstname;
      this.lname = this.$store.state.UserDetails.user.lastname;
      this.telephone = Number(this.$store.state.UserDetails.user.telephone);
      this.gender = this.$store.state.UserDetails.user.gender;
      this.location = this.$store.state.UserDetails.user.location;
      this.age = this.$store.state.UserDetails.user.age;
    },
  },
  computed: {
    user() {
      return this.$store.state.UserDetails.user;
    },
  },
  created() {
    const token = localStorage.getItem("jwt");
    const decoded = jwt_decode(token);
    const userRole = decoded.role;
    if (userRole != "shaloi") return router.push("/dashboard");
    this.getShaloiStatus();
    $(document).ready(function() {
      $(".show-modal").click(function() {
        $("#myModal").modal({
          backdrop: "static",
          keyboard: false,
        });
      });
    });
  },
  mounted() {
    const token = localStorage.getItem("jwt");
    const decoded = jwt_decode(token);
    const userRole = decoded.role;
    if ( userRole != "shaloi") {
          clearInterval(getRoleInterval);
          return router.push("/dashboard");
    }
      
  },
};
</script>

<style lang="scss" scoped>
#entire_app__profile {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  display: flex;
  flex-wrap: wrap;
   .--booking_in_progress {
      display: block !important;
    }

   .ticket_booking_order {
    position: absolute;
    width: 100%;
    height: 100%;
    background: transparent;
    z-index: 999;
    display: none;
    transition: all 0.5s ease;

    .ticking_procedure_background {
      position: fixed;
      width: 100%;
      height: 100%;
      background-color: $dimestDark;
      opacity: 0.55;
    }

    .loading_data_background {
      background-color: $pureWhite !important;
      opacity: 1 !important;
    }

    .error_occurred_container {
      width: 100%;
      height: 100vh;
      background-color: transparent;
      display: flex;
      justify-content: center;
      align-items: center;

      .loading_container {
        flex-direction: column;
        .logo {
          width: 30%;
        }

        .loader {
          width: 10%;
          margin-top: 2em;
        }
      }

      .alert_container {
        position: fixed;
        background-color: $pureWhite;
        width: 40%;
        height: auto;
        min-height: 28% !important;
        z-index: 99;
        border-radius: 0.5em;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all .5s ease !important;
        padding: 0.2em;

        .error_image {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 30%;
          height: 100%;

          img {
            width: 85%;
            height: auto;
          }
        }

      }
    }

    .ticket_booking_procedure_container {
      width: 100%;
      height: 100%;
      background-color: transparent;
      display: flex;
      justify-content: center;
      align-items: center;
      position: fixed;

      .procedure_form {
        position: fixed;
        background-color: $pureWhite;
        width: 35%;
        height: auto;
        min-height: 80%;
        z-index: 99;
        border-radius: 0.5em;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all .5s ease !important;
      }
    }
  }
  
  .entire_app_mobile_sidebar_container {
    display: none;
  }

  .__mobile_navigation {
    display: none;
  }

  .--sidebar_toggled {
    width: 6.5% !important;
    height: 100% !important;
  }

  .--sidebar_toggled_expd_body {
    width: 93.5% !important;
  }

  & .entire_app__sidebar_container {
    width: 17%;
    height: 100%;
    background: $mainDimBlue;
    transition: 0.2s ease;
  }

  & .entire_app__page_content {
    width: 83%;
    height: 100%;
    background: $pureWhite;
    transition: 0.2s ease;
    font-family:satoshi, $poppins, Roboto, "Helvetica Neue", Arial, "Noto Sans",
      sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol",
      "Noto Color Emoji" !important;
    overflow-y: scroll !important;
  }
  label {
    font-family:satoshi, $poppins, Roboto, "Helvetica Neue", Arial, "Noto Sans",
      sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol",
      "Noto Color Emoji" !important;
  }
  h5 {
    color: $gradientDark;
    padding: 10px;
    font-size: 0.9em;
    border-bottom: 2px solid $mainDimBlue;
    padding-bottom: 0.6%;
  }
  .form {
    height: auto;
    background-color: #eaedf485;
    display: flex;
    justify-content: center;
    padding: 1.5em 0;
    width: 97%;
  }
  .edit{
    margin: 0!important ;
    position: relative;
    left: -6.4em;
    width: fit-content;
    padding: 0 5px!important;
  }
  form {
    width: 85%;
    height: 100%;
  }
  .pair {
    display: flex;
    justify-content: space-between !important;
    height: 12%;
    margin: 2% 0;
    width: 100% !important;
  }
  .loading {
    display: flex;
    width: fit-content;
    margin: 15px auto;
  }
  .loading p {
    font-size: 13px;
    margin: 0 10px;
  }
  .phone_number_update {
    background-color: #eaedf485;
    width: 97%;
    border-radius: 5px;
    justify-content: center;
    height: auto;
    padding: 1em 0;
    margin: 1em auto;
  }
  .phone_number_update form {
    display: flex;
    margin: 0 auto;
  }
  .phone_number_update label {
    position: relative;
    left: 5.5em;
    font-size: 14px;
    font-weight: 500;
  }
  .phone_number_update button {
    height: 40px !important;
    margin: 0 7em;
    font-size: 13px !important;
    padding: 0 2.8em;
    background-color: #487fff;
    color: white;
  }

  .input-item {
    display: flex;
    flex-direction: column;
    width: 45%;
    height: 100%;
    font-size: 0.9em;

    input,
    select {
      height: 40px !important;
      border-radius: 5px;
      border: 2px solid #6b95f888;
      background-color: $bookingInputs;
      padding: 0 2%;
      font-size: 0.95em;
      font-weight: 500;
      outline: none;
    }
    label {
      color: rgb(85, 83, 83);
      font-weight: 500;
    }
  }
  .imgpair {
    display: flex;
    justify-content: space-between;
    height: 30%;
    margin: 2% 0 !important;

    .input-pair {
      display: flex;
      flex-direction: column;
      width: 45%;
      height: 100% !important;

      .input-item {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 40% !important;
      }
      .location {
        margin-bottom: 5%;
      }
    }
    .input-img {
      display: flex;
      flex-direction: column;
      width: 45%;
      height: 100% !important;
      font-size: 0.9em;

      label {
        color: rgb(85, 83, 83);
        font-weight: 500;
      }
    }
  }
  .output {
    width: 7.8rem;
    height: 7.8rem;
    margin: auto;
    overflow: hidden;
    display: flex;
    align-items: center;
    position: relative;
  }
  .output img {
    width: inherit;
    height: inherit;
    border-radius: 50%;
    border: 1px solid #6b95f888;
  }
  .output .pencil {
    position: absolute;
    bottom: 5%;
    right: 5%;
    cursor: pointer;
  }
  .profilepic {
    display: none;
  }
  .buttons {
    display: flex;
    justify-content: space-between;
    margin-top: 5% !important;
    /* justify-content: flex-start; */
    font-size: 0.85em;
    height: 7%;
    margin: auto;
    width: 50%;
  }
  .buttons button {
    width: 40%;
    height: 40px !important;
    min-width: fit-content;
    border: none;
    border-radius: 5px;
    color: white;
  }
  .buttons .good {
    background-color: $mainBlue;
  }
  .buttons .bad {
    background-color: $incardtext;
  }
  .regbp {
    width: 80% !important;
    /* height: 30px !important; */
    margin: auto;
    margin-top: 5%;
    margin-bottom: 5%;
    display: flex;
    justify-content: space-between;
    button {
      width: 45% !important;
      font-size: 0.8em !important;
      /* height: 100% !important; */
    }
  }

  .modal-dialog {
    /* height: 68%; */
    margin: auto;
    /* height: 100%; */
  }
  .modal-body {
    /* background-color: green; */
    display: flex !important;
    flex-direction: column;
    justify-content: center !important;
    /* height: 50vh !important; */
  }
  .modalform {
    height: fit-content;
    margin: auto;

    .form-group {
      margin: 2% 5% !important;
    }

    p {
      margin-top: 3.5%;
      margin-bottom: 1.5%;
    }
    .bptobp {
      justify-content: space-between;

      .form-group {
        width: 50% !important;
      }
    }
  }
  .modal-content {
    height: 100%;
  }
}
@media only screen and (max-width: 600px) {
	#entire_app__profile {
    height: auto;

      .ticket_booking_order {
        .ticket_booking_procedure_container {
          .procedure_form {
            width: 92%;
          }
        }
      }
			.__mobile_navigation {
				display: block;
				width: 100%;
				height: 9vh;
				background: $pureWhite;
				position: fixed;
				top: 0;
				z-index: 5;

				 & .logo_container {
            width: 100%;
            height: 100%;
            display: flex;
            flex-wrap: wrap;

            .menu_toggle {
                width: 22%;
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;
            }

            .--full_width {
                width: 100% !important;
                height: 50% !important;
            }

            .--sidebar_toggled_hide_logo {
                display: none !important;
            }

            .logo {
                width: 56%;
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;

                img {
									width: 60%;
									margin-top: 0.2em;
                }
            }

            .settings {
							width: 22%;
							height: 100%;
							display: flex;
							justify-content: center;
							align-items: center;
							cursor: pointer;
            }
        }

			}

			.entire_app__sidebar_container{
				display: none;
			}

			.entire_app__page_content {
				display: block;
				width: 100%;

				.form {
					margin-top: 9vh;
					width: 100% !important;

          .pair,.imgpair{
            display: flex;
            flex-direction: column;
            width: 100% !important;
          }
          .input-item,.input-img,.imgpair,.input-pair{
            width: 100% !important;
          }
          .buttons {
          justify-content: space-around;
          width: 100%;
          }
          .buttons button {
            width: 45%;
          }
				}

        .phone_number_update label {
          left: 0;
          text-align: center;
        }
        .phone_number_update button {
          height: 40px !important;
          margin: 0 3em;
        }

				.notifications_container {
					display: none;
				}
			}

      .entire_app_mobile_sidebar_container {
        display: block;
        transition: all .5s ease;
        z-index: 4;
        width: 100%;
        height: 92vh;
        background: $pureWhite;
        position: fixed;
        top: 8vh;
        animation: slide_up .2s linear;
      }

      @keyframes slide_up {
        0% {
          top: 8vh;
        }50%{
          top: 5vh;
        }100%{
          top: 8vh;
        }
      }
		}
}
</style>
